import { NgModule } from '@angular/core';
import { MullionsService } from '@icc/construction-elements/configurator';
import { AlignmentsService } from '../../layout/alignments.service';
import { ExtensionsService } from '../../layout/extensions.service';
import { ThresholdsService } from '../../layout/thresholds.service';
import { BrowserShapeService } from './shape.service';
import { ShapeService } from '../../shape.service';
import { RemoveSashService } from './remove-sash.service';
import { MullionsLayoutService } from './mullions-layout.service';
import { SashTypesService } from './sash-types.service';
import { SplitSashService } from './split-sash.service';
import { ResizeService } from './resize.service';
import { ResizeSashService } from './resize-sash.service';
import { SashesLayoutService } from './sashes-layout.service';
import { FramesService } from './frames.service';
import { ResizeFrameService } from './resize-frame.service';
import { SplitFrameService } from './split-frame.service';
import { EqualDivisionService } from './equal-division.service';
import { FixSashThresholdService } from './fix-sash-threshold.service';
import { LayoutService } from './layout.service';
import { ConstructionCodeService } from './construction-code.service';
import { DimensionsModule } from '../dimensions/dimensions.module';

@NgModule({
    imports: [DimensionsModule],
    exports: [],
    declarations: [],
    providers: [
        MullionsService,
        AlignmentsService,
        ExtensionsService,
        BrowserShapeService,
        { provide: ShapeService, useExisting: BrowserShapeService },
        FramesService,
        ThresholdsService,
        RemoveSashService,
        MullionsLayoutService,
        SashesLayoutService,
        SashTypesService,
        SplitSashService,
        LayoutService,
        ResizeService,
        ResizeSashService,
        ResizeFrameService,
        SplitFrameService,
        EqualDivisionService,
        FixSashThresholdService,
        ConstructionCodeService,
    ],
})
export class LayoutModule {}
